import { ReactComponent as AccountIcon } from '../../assets/img/icon/Account.svg';
import { ReactComponent as DashboardIcon } from '../../assets/img/icon/Dashboard.svg';
import { ReactComponent as DocumentationIcon } from '../../assets/img/icon/Documentation.svg';
import Account from '../../screens/PrivateLayout/Account/Accont.component';
import ChangePassword from '../../screens/PrivateLayout/Account/ChangePassword/ChangePassword.component';
import EditProfile from '../../screens/PrivateLayout/Account/EditProfile/EditProfile.component';
import IncidentDetails from '../../screens/PrivateLayout/Account/Incidents/IncidentDetails/IncidentDetails.component';
import Incidents from '../../screens/PrivateLayout/Account/Incidents/Incidents.component';
import EditPaymentMethod from '../../screens/PrivateLayout/Account/ModifiedPayments/EditPaymentMethod.component';
import ModifiedPayments from '../../screens/PrivateLayout/Account/ModifiedPayments/ModifiedPayments.component';
import MainPayments from '../../screens/PrivateLayout/Account/Payments/MainPayments.component';
import MaturitiesDetails from '../../screens/PrivateLayout/Account/Payments/PaymentDetails/MaturitiesDetails.component';
import PaymentDetails from '../../screens/PrivateLayout/Account/Payments/PaymentDetails/PaymentDetails.component';
import Payments from '../../screens/PrivateLayout/Account/Payments/Payments.component';
import Assistance from '../../screens/PrivateLayout/Assitances/Assistances.component';
import AssistancesStatus from '../../screens/PrivateLayout/Assitances/AssistancesStatus.component';
import CirculationCardDetails from '../../screens/PrivateLayout/CirculationCardDetails/CirculationCardDetails.component';
import CirculationCardsList from '../../screens/PrivateLayout/CirculationCardsList/CirculationCardsList.component';
import Dashboard from '../../screens/PrivateLayout/Dashboard/Dashboard.component';
import Documentation from '../../screens/PrivateLayout/Documentation/Documentation.component';
import CertificateOfCoverage from '../../screens/PrivateLayout/Documentation/Documents/CertificateOfCoverage.component';
import MercosurCertificate from '../../screens/PrivateLayout/Documentation/Documents/MercosurCertificate.component';
import PaymentPerDay from '../../screens/PrivateLayout/Documentation/Documents/PaymentPerDay.component';
import Policy from '../../screens/PrivateLayout/Documentation/Documents/Policy.component';
import ProductPaymentPerDay from '../../screens/PrivateLayout/Documentation/Documents/ProductPaymentPerDay.component';
import ProductPolicy from '../../screens/PrivateLayout/Documentation/Documents/ProductPolicy.component';
import Product from '../../screens/PrivateLayout/Documentation/Product/Product.Component';
import Vehicle from '../../screens/PrivateLayout/Documentation/Vehicle/Vehicle.component';
import VehicleDetails from '../../screens/PrivateLayout/Documentation/Vehicle/VehicleDetails.component';
import CancelPolicy from '../../screens/PrivateLayout/Endorsements/CancelPolicy/CancelPolicy';
import InitCancel from '../../screens/PrivateLayout/Endorsements/CancelPolicy/InitCancel';
import Endorsements from '../../screens/PrivateLayout/Endorsements/Endorsements.component';
import InitFlow from '../../screens/PrivateLayout/Endorsements/Endorsements/InitFlow';
import EndorsementVehicle from '../../screens/PrivateLayout/Endorsements/Vehicle/VehicleDetails.component';
import InspectionsWrapped from '../../screens/PrivateLayout/Inspections/Inspections';
import PreviousInspections from '../../screens/PrivateLayout/Inspections/components/PreviousInspections/PreviousInspections';
import SinisterInspections from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/SinisterInspections';
import SinisterMethod from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/SinisterMethod';
import FastManagement from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/externalFlow/FastManagement';
import PhotographicInspection from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/externalFlow/PhotographicInspection';
import CoordinatedInspection from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/CoordinatedInspection';
import InitInspection from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/InitInspection';
import Notifications from '../../screens/PrivateLayout/Notifications/Notifications.component';
import SelfInspection from '../../screens/PrivateLayout/SelfInspection/SelfInspection.component';
import MainClaims from '../../screens/PrivateLayout/Sinister/MainClaims.component';
import Sinister from '../../screens/PrivateLayout/Sinister/Sinister.component';
import UserAttention from '../../screens/PrivateLayout/UserAttention/UserAttention.component';
import UserFAQ from '../../screens/PrivateLayout/UserAttention/UserFAQ.component';
import Redirect from '../../screens/Redirect';

export const routes = [
  {
    path: '/documentation/product/:id',
    component: Product,
    noDrawer: true,
  },
  {
    path: '/dashboard',
    name: 'Inicio',
    icon: DashboardIcon,
    component: Dashboard,
    order: 1,
  },
  {
    path: '/circulation-cards',
    component: CirculationCardsList,
    noDrawer: true,
  },
  {
    path: '/circulation-card/:id',
    component: CirculationCardDetails,
    noDrawer: true,
  },
  {
    path: '/documentation/vehicle/details/:id',
    component: VehicleDetails,
    noDrawer: true,
  },
  {
    path: '/documentation/document/policy/:id',
    component: Policy,
    noDrawer: true,
  },
  {
    path: '/documentation/document/product_policy',
    component: ProductPolicy,
    noDrawer: true,
  },
  {
    path: '/documentation/document/payments_per_day/:id',
    component: PaymentPerDay,
    noDrawer: true,
  },
  {
    path: '/documentation/document/product_payments_per_day',
    component: ProductPaymentPerDay,
    noDrawer: true,
  },
  {
    path: '/documentation/document/certificate_of_coverage/:id',
    component: CertificateOfCoverage,
    noDrawer: true,
  },
  {
    path: '/documentation/document/mercosur_certificate/:id',
    component: MercosurCertificate,
    noDrawer: true,
  },
  {
    path: '/documentation/vehicle/:id',
    component: Vehicle,
    noDrawer: true,
  },
  {
    path: '/documentation',
    name: 'Mis pólizas',
    icon: DocumentationIcon,
    component: Documentation,
    order: 3,
  },
  {
    path: '/account/change-password',
    component: ChangePassword,
    noDrawer: true,
    root: 'account',
    name: 'Cambiar Contraseña',
  },
  {
    path: '/account/edit-profile',
    component: EditProfile,
    noDrawer: true,
    root: 'account',
    name: 'Editar perfil',
  },
  {
    path: '/account/payment/:id/maturities',
    component: MaturitiesDetails,
    noDrawer: true,
    root: 'account',
    name: 'Pagos pendientes',
  },
  {
    path: '/account/payment/:id',
    component: PaymentDetails,
    noDrawer: true,
    root: 'account',
    name: 'Detalle de pago',
  },
  {
    path: '/main_payments',
    component: MainPayments,
    name: 'Pagos',
    // noDrawer: true,
    order: 5,
    root: 'account',
  },
  {
    path: '/account/payments',
    component: Payments,
    name: 'Mis pagos',
    noDrawer: true,
  },
  {
    path: '/account/incidents',
    component: Incidents,
    name: 'Mis denuncias',
    noDrawer: true,
    root: 'account',
  },
  {
    path: '/account/modified_payments',
    component: ModifiedPayments,
    noDrawer: true,
    root: 'account',
  },
  {
    path: '/edit_payment_method/:policy_id',
    component: EditPaymentMethod,
    noDrawer: true,
  },
  {
    path: '/account/incidentDetails/:id',
    component: IncidentDetails,
    noDrawer: true,
    root: 'account',
  },
  {
    path: '/account',
    name: 'Cuenta',
    icon: AccountIcon,
    component: Account,
    order: 2,
    root: 'account',
  },
  {
    path: '/assistance/:id',
    component: AssistancesStatus,
    noDrawer: true,
  },
  {
    path: '/assistance',
    component: Assistance,
    name: 'Grúa',
    // noDrawer: true,
    order: 6,
    hasOwnBradcrumb: true,
  },
  {
    path: '/claims',
    component: MainClaims,
    name: 'Siniestros',
    // noDrawer: true,
    order: 7,
  },
  {
    path: '/sinister',
    component: Sinister,
    name: 'Siniestros',
    noDrawer: true,
    hasOwnBradcrumb: true,
  },
  {
    path: '/notifications',
    component: Notifications,
    name: 'Notificaciones',
    // noDrawer: true,
    order: 4,
  },
  {
    path: '/selfInspection/:id',
    component: SelfInspection,
    noDrawer: true,
  },
  {
    path: '/selfInspection',
    component: SelfInspection,
    noDrawer: true,
  },
  {
    path: '/endorsements/vehicle/details/:id',
    component: EndorsementVehicle,
    noDrawer: true,
  },
  {
    path: '/endorsements/process/:id',
    component: InitFlow,
    noDrawer: true,
  },
  {
    path: '/endorsements',
    component: Endorsements,
    noDrawer: true,
  },
  {
    path: '/inspections/previous',
    name: 'Inspecciones Previas',
    noDrawer: true,
    component: PreviousInspections,
  },
  {
    path: '/inspections',
    name: 'Inspecciones',
    noDrawer: true,
    component: InspectionsWrapped,
  },
  {
    path: '/cancel-policy/vehicle/:policy_id',
    component: CancelPolicy,
    noDrawer: true,
  },

  {
    path: '/cancel-policy',
    component: InitCancel,
    noDrawer: true,
  },
  {
    path: '/sinister-inspections',
    component: SinisterInspections,
    noDrawer: true,
  },
  {
    path: '/sinister-method',
    component: SinisterMethod,
    noDrawer: true,
  },
  {
    path: '/coordinated-inspection/:id',
    component: CoordinatedInspection,
    noDrawer: true,
  },
  {
    path: '/photographic-inspection',
    component: PhotographicInspection,
    noDrawer: true,
  },
  {
    path: '/fast-management',
    component: FastManagement,
    noDrawer: true,
  },
  {
    path: '/mechanical-inspection',
    component: InitInspection,
    noDrawer: true,
  },
  {
    path: '/redirect',
    component: Redirect,
    noDrawer: true,
  },
];

export const linkedRoutes = [
  {
    path: '/user-attention',
    name: 'Atención y consultas',
    component: UserAttention,
    order: 1,
  },
  {
    path: '/user-faq',
    name: 'Preguntas frecuentes',
    component: UserFAQ,
    noDrawer: true,
  },
  {
    path: '/',
    redirect: '/dashboard',
    noDrawer: true,
  },
];
